import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create, string } from "superstruct";
import { inject, singleton } from "tsyringe";

import { lambdaApiClientToken } from "../di_tokens";

@singleton()
class CustomerApiService {
    public constructor(
        @inject(lambdaApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public getCustomerStoreCredit(): Observable<string> {
        return this.apiClient
            .get({
                url: "/storeCreditBalance",
                responseType: "json",
            })
            .pipe(map((response) => create(response.body, string())));
    }
}

export default CustomerApiService;
